import candidateRow from "../candidates/candidateRow"
import resultsBoxHeader from "./resultsBoxHeader"

/**
 * Import CSS file for this component and its children
 */
// import demoStyles from "../../css/demo.css";

export default {
    name: 'ResultsBoxMain',

    components: {
        candidateRow,
        resultsBoxHeader
    },

    setup() {

    },

    template: /*html*/`
        <div class="cfm_ec_results_box">
            <results-box-header></results-box-header>

            <candidate-row
            name="Yes"
            votes="52572"
            votesPercent="39.1"
            showProgressBar="true"
            ></candidate-row>

            <candidate-row
            name="No"
            votes="81804"
            votesPercent="60.9"
            showProgressBar="true"
            ></candidate-row>


            <candidate-row
            name="Total"
            votes="134376"
            votesPercent=""
            showProgressBar="false"
            ></candidate-row>
        </div>
    `,
}